/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {EditorState} from 'prosemirror-state';
import {EditorView} from 'prosemirror-view';
import {LocalsKeys} from './Locals';

type TCR = { dom: any, update: (state: EditorState) => void };

export type TBHeadingItems = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export type TBTextSizeItems = 'fontSize8' | 'fontSize9' | 'fontSize10' | 'fontSize11' | 'fontSize12' | 'fontSize13'
    | 'fontSize14' | 'fontSize15' | 'fontSize16' | 'fontSize17' | 'fontSize18' | 'fontSize19'
    | 'fontSize20' | 'fontSize21' | 'fontSize22' | 'fontSize23' | 'fontSize24';
export type TBItems = 'table' | 'bold' | 'italic'
    | 'code' | 'blockquote'
    | 'underline' | 'strike'
    | 'ordered_list' | 'bullet_list'
    | 'link' | 'image'
    | 'text_color' | 'background_color'
    | 'align_left' | 'align_center' | 'align_right' | 'align_justify';

export type ToolbarDropdown = { heading?: TBHeadingItems[] };
export type TextSizeDropdown = { fontGroup?: TBTextSizeItems[] };
export type ToolbarCustomMenuItem = (editorView: EditorView) => TCR;
export type ToolbarItem = TBItems | ToolbarDropdown | ToolbarCustomMenuItem | TextSizeDropdown;
export type Toolbar = Array<ToolbarItem[]>;

export interface FcAgEditorConfig {
    locals?: Partial<Record<LocalsKeys, string>>;
}
